import { norlizeColumns } from 'utils/handle'
import { StatusValidDisplayEnmus } from 'utils/enmus'

// 字典组
const DictGroupColumnsMaps = new Map()
DictGroupColumnsMaps.set('code', '编码')
DictGroupColumnsMaps.set('name', '名称')
DictGroupColumnsMaps.set('createTime', '创建时间')

class DictGroup {
    constructor(v) { // 构造函数
        v = v || {}
    }
    static get tableColumns () {
        return norlizeColumns(
            ['index, 50', 'code', 'name', 'createTime'],
            DictGroupColumnsMaps
        )
    }
}

// 字典项
const DictColumnsMaps = new Map()
DictColumnsMaps.set('code', '编码')
DictColumnsMaps.set('name', '名称')
DictColumnsMaps.set('createTime', '创建时间')
DictColumnsMaps.set('status', {
    label: '状态',
    formatter: row => StatusValidDisplayEnmus.find(v => v.value === row.status).label
})


class Dict {
    constructor(v) { // 构造函数
        v = v || {}
    }

    static get tableColumns () {
        return norlizeColumns(
            ['index, 50', 'code', 'name', 'status', 'createTime'],
            DictColumnsMaps
        )
    }
}


export {
    DictGroup,
    Dict
}


// WEBPACK FOOTER //
// ./src/views/system-manage/systemDTO.js